// @ts-nocheck
import { useMemo } from 'react';
import { Grid, Typography } from '@mui/material';
import { CautionIcon } from 'pages/Forms/RegisterForm/CustomFormBuilder/Header/Preview/YesNoNaFormFieldPreview/config/yesnonaSvgs';
import { useStyles } from '../style/style';

const ActionMessage = ({ field }) => {
  const classes = useStyles();
  const showActionMessage = useMemo(
    () =>
      field.choice.reduce(
        (prevValue, choice) =>
          prevValue || (choice.action && field.answer.includes(choice.id)),
        false,
      ),
    [field],
  );

  if (showActionMessage && field.actionMessage) {
    return (
      <Grid className={classes.cautionBox}>
        <span style={{ marginLeft: 5 }}>{CautionIcon}</span>
        <Typography className={classes.cautionText} variant="body2">
          {field.actionMessage}
        </Typography>
      </Grid>
    );
  }

  return null;
};

export default ActionMessage;
